import { ContractDetails } from "@/@client/Theasoft_ApiServer_Contracts"
import { DetailsCard } from "@/routes/app/-components/details-card"
import { IconCheckBox } from "@/routes/app/-components/icon-check-box"
import { PersonLink } from "@/routes/app/art/activities/-components/-tabs/CastsTab/person-links"
import { useGetFormattedDatePeriod } from "@/utils/use-get-formatted-date-period"
import { LabeledValue } from "@components/default-list/labeled-value"
import { DefaultListItem } from "@components/default-list/list-item"
import { useTranslation } from "react-i18next"

interface Props {
  contract: ContractDetails
}

export function ContractDetailsCard({ contract }: Props) {
  const { t } = useTranslation("app_server")
  const getFormattedDatePeriod = useGetFormattedDatePeriod()
  const items: { label: string; value: React.ReactNode }[] = [
    {
      label: t("TimePeriod"),
      value: getFormattedDatePeriod(contract.startDate, contract.endDate),
    },
    {
      label: t("Name"),
      value: <PersonLink personId={contract.personId} />,
    },
    { label: t("ContractType"), value: contract.contractTypeName },
    { label: t("Status"), value: contract.approvalStatus?.name },
    { label: t("Department"), value: contract.departmentName },
    { label: t("Agency"), value: contract.agency },
    {
      label: t("PrimaryContract"),
      value: contract.isPrimary && (
        <IconCheckBox checked={contract.isPrimary} />
      ),
    },
    {
      label: t("Canceled"),
      value: contract.isCancel && <IconCheckBox checked={contract.isCancel} />,
    },
  ]
  return (
    <DetailsCard stackProps={{ gap: "xs" }} title={t("Details")}>
      {items
        .filter((item) => !!item.value)
        .map((item, i) => (
          <DefaultListItem key={i}>
            <LabeledValue label={item.label} value={item.value} />
          </DefaultListItem>
        ))}
    </DetailsCard>
  )
}
